import HeroB from "tm/heroB";

export { HeroB };

customElements.define("tm-hero-b", HeroB.CustomElementConstructor);
